<div class="forgot-password-page-wrapper">
  <payee-header></payee-header>
  <div class="header-divider"></div>

  <div class="forgot-password-container-wrapper">
    <div class="forgot-password-container">
      <h1 class="forgot-password-title">
        {{ "GET_PASSWORD_RESET_LINK.TITLE" | translate }}
      </h1>

      <!-- Email Form -->
      <form
        class="forgot-password-form"
        [formGroup]="forgotPasswordForm"
        (ngSubmit)="sendEmail()"
      >
        <div class="form-field-wrapper">
          <span class="form-label">{{ "LOGIN.EMAIL_LABEL" | translate }}</span>
          <payee-form-field
            width="wide"
            class="form-field"
          >
            <input
              payee-input
              formControlName="email"
              type="email"
              autocomplete="email"
              inputmode="email"
              class="form-input"
            />
            @if (email.dirty) {
              <ng-container payee-error>
                @if (email.hasError("email")) {
                  <mat-error>
                    {{ "ERROR_MESSAGES.INVALID_EMAIL" | translate }}
                  </mat-error>
                }
                @if (email.hasError("required")) {
                  <mat-error>
                    {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
                  </mat-error>
                }
              </ng-container>
            }
          </payee-form-field>
        </div>

        <input
          type="submit"
          hidden
        />

        <button
          payee-button
          width="wide"
          color="blue-payee"
          type="submit"
          class="forgot-password-button"
          [disabled]="loading()"
          [isRoundButton]="false"
        >
          @if (!loading()) {
            <span>{{ "GET_PASSWORD_RESET_LINK.REQUEST_BUTTON" | translate }}</span>
          }
          @if (loading()) {
            <span>{{ "LOGIN.LOADING" | translate }}</span>
          }
        </button>

        <!-- Secondary CTAs -->
        <div class="forgot-password-cta-wrapper">
          <a
            routerLink="/login"
            style="text-decoration: none; display: block"
          >
            <button
              type="button"
              payee-button
              width="wide"
              color="white"
              class="secondary-cta-button"
              [isBorderButton]="true"
            >
              {{ "GET_PASSWORD_RESET_LINK.BACK_TO_LOGIN" | translate }}
            </button>
          </a>
        </div>
        <div class="forgot-password-cta-wrapper">
          <a
            routerLink="/signup"
            style="text-decoration: none; display: block"
          >
            <button
              type="button"
              payee-button
              width="wide"
              color="white"
              class="secondary-cta-button"
              [isBorderButton]="true"
            >
              {{ "GET_PASSWORD_RESET_LINK.SIGN_UP_CTA" | translate }}
            </button>
          </a>
        </div>
      </form>
    </div>
  </div>

  <app-footer-simple></app-footer-simple>
</div>
